import { Injectable } from '@angular/core';
import { UserDataApi } from '@ddt-web/domain';
import { Observable, of } from 'rxjs';

@Injectable()
export class MockUserDataApiService implements UserDataApi {
	

	public getAllJson(): Observable<any> {
		return of({ message: 'Hello World' });
	}
}
